import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { Scrollbars } from 'react-custom-scrollbars';
import Loading from 'layout/Loading';
import BasicInfoItem from './BasicInfoItem';
import withDropdown from '../withDropdown';

const styles = theme => ({
  input: {},
  row: {},
  caption: {
    color: theme.palette.primary.main,
  },
  paper: {
    width: 300,
    height: 267,
    [theme.breakpoints.down('xs')]: {
      height: 244,
    },
    display: 'table-cell',
    verticalAlign: 'middle',
  },
  title: {
    display: 'flex',
  },
});

export const BasicInformation = (props) => {
  const {
    classes,
    title,
    loading,
    isWithDropdown,
    data,
  } = props;

  const hasData = data && Object.keys(data).length > 0;
  return (
    <div>
      {!isWithDropdown && (
      <Typography className={classes.title} variant="subheading">
        {title}
      </Typography>
      )}
      <Paper className={classes.paper}>
        {loading ? <Loading />
          : hasData
            ? (
              <Scrollbars style={{ borderRadius: '4px' }}>
                {Object.keys(data).map((key, index, array) => (
                  index === array.length - 1
                    ? (
                      <BasicInfoItem
                        key={key}
                        title={key ? key.toString() : 'Unknown'}
                        text={data[key] != null ? data[key].toString() : 'Unknown'}
                        lastItem
                      />
                    ) : (
                      <BasicInfoItem
                        key={key}
                        title={key ? key.toString() : 'Unknown'}
                        text={data[key] != null ? data[key].toString() : 'Unknown'}
                      />
                    )

                ))}
              </Scrollbars>
            ) : isWithDropdown ? 'No selected data' : 'No available data' }
      </Paper>
    </div>
  );
};

BasicInformation.defaultProps = {
  loading: false,
  isWithDropdown: false,
};

BasicInformation.propTypes = {
  data: PropTypes.oneOfType([PropTypes.shape(), PropTypes.arrayOf(PropTypes.shape())]).isRequired,
  title: PropTypes.string.isRequired,
  classes: PropTypes.shape({}).isRequired,
  loading: PropTypes.bool,
  isWithDropdown: PropTypes.bool,
};

export default withStyles(styles)(BasicInformation);
const BasicInformationWithDropdown = withDropdown(withStyles(styles)(BasicInformation));
export { BasicInformationWithDropdown };



// WEBPACK FOOTER //
// ./src/components/overview/BasicInformation/BasicInformation.jsx